module.exports = __webpack_public_path__ + "img/commercial_and_customer_experience.1f4b567a.png";